import React from 'react';
import { Link } from 'react-router-dom';
import why_work from '../../assets/images/why-work.png';
import MainAuthModalView from './MainAuthModal';


const MainAuthView = (props) => {
    return (
        <>

            <section className="login-wrapper" style={{minHeight:'100vh'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                             <h2 style={{textAlign: 'end',color:'#e0413b',cursor:'pointer'}} onClick={props.showCustomModal} >Pin Entry</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                             <h2 style={{textAlign: 'center',color:'white'}}>Under Construction</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="login-form-main">
                                <div className="registration-form_wrapper">
                                     <div className="content">
                                        <img src={why_work} alt="" />
                                        <h3>carerconnect</h3>
                                        <h4>Whenever Wherever</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div className="col-lg-6">
                            <div className="login-form-main">
                                <div className="registration-form_wrapper" style={{padding: '50px 45px'}}>
                                     <div className="content">
                                        <h2 style={{textAlign:'center',marginBottom:'13px'}}>We're Hiring</h2>
                                        <p>
                                            We're accepting applications for positions in the community and with the local authorities in your area.
                                        </p>
                                        <p>
                                            Please take a moment to register with the site and submit your cv. One of our friendly staff members will be in touch shortly afterwards to assign you with the on boarding process. We are an inclusive agency and welcome all openly and equally. To learn more please start here otherwise hit the join us button below to submit your cv.
                                        </p>
                                        <div className="login-form w-75" >
                                           <form>
                                            <div className="field-box">
                                                <button onClick={props.joinourteam} type="button">Join Our Team <i className="fa fa-sign-in"></i></button>
                                            </div>
                                           </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <MainAuthModalView
                    modal_show={props.modal_show}
                    showCustomModal= {props.showCustomModal}
                    hideCustomModal={props.hideCustomModal}
                    timeleft={props.timeleft}
                    handelValue ={props.handelValue}
                    handelSummit={props.handelSummit}
                />
            </section>

        </>
    )
}

export default MainAuthView;
